import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Image, Modal, Upload, Button } from "antd";
import HeadingBack from "../components/common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import SvgIcon from "../components/const/SvgIcon";
import { allApiAction } from "../Redux/common/action";
import { DeleteOutlined, ExclamationCircleFilled, PlusOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";

const defaultObj = {
  title: "",
  description: "",
  image: "",
  files: "",
};

function Gallery() {
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [galleryDetails, setGalleryDetails] = useState({ ...defaultObj });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const token = localStorage.getItem("admin_token");

  const { galleryList } = useSelector((state) => ({
    galleryList: state?.allApi?.gallery_list || {},
  }));

  const listData = galleryList?.data ? galleryList?.data : [];

  useEffect(() => {
    dispatch(allApiAction.getGallery({ page: page, search: search }));
  }, [search, page]);

  const columns = [
    {
      width: "10%",
      title: "Image",
      dataIndex: "image",
      render: (value, item) => (
        <div style={{ width: "60px" }}>
          <Image src={URL.API_BASE_URL + item.image} alt="N/A" preview />
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <div dangerouslySetInnerHTML={{ __html: text }} style={{ wordBreak: "break-word" }} />
      ),
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item) => (
        <>
          <Tooltip title="Edit">
            <span
              className="cursor-pointer"
              onClick={() => {
                handleModal(item);
              }}
            >
              <SvgIcon.Edit className="scale-icon edit-icon" />
            </span>
          </Tooltip>
          <Tooltip title="Delete">
            <span
              className="cursor-pointer"
              onClick={() => showDeleteConfirm(item?.id)}
            >
              <SvgIcon.deletebtn className="scale-icon edit-icon" />
            </span>
          </Tooltip>
        </>
      ),
    },
  ];

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure delete?",
      icon: <ExclamationCircleFilled />,
      content: "Gallery Item",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleDelete = async (id) => {
    setShowDelete(false);
    await dispatch(allApiAction.deleteGallery({ id: id, page }));
    dispatch(allApiAction.getGallery({ page }));
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files) {
      setSelectedFile(files);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setGalleryDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleModal = (editData) => {
    if (editData) {
      setGalleryDetails(editData);
    } else {
      setGalleryDetails({ ...defaultObj });
      setFileList([]);
      setSelectedFile(null);
    }
    setIsModalOpen(true);
  };

  const handleSubmit = async () => {
    const data = new FormData();
    data.append("title", galleryDetails.title);
    data.append("description", galleryDetails.description);

    if (selectedFile) {
      for (let i = 0; i < selectedFile.length; i++) {
        data.append("image", selectedFile[i]);
      }
    }

    try {
      if (galleryDetails.id) {
        data.append("id", galleryDetails.id);
        await dispatch(allApiAction.updateGallery(data));
      } else {
        await dispatch(allApiAction.addGallery(data));
      }
      dispatch(allApiAction.getGallery({ page: 1 }));
      handleModal();
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div>
      <div className="flex">
        <div>
          <HeadingBack
            title="Gallery"
            subHeading={`Total ${galleryList?.total || 0} Items`}
          />
        </div>

        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className="table antd_table"
          pagination={{
            current: page,
            pageSize: 10,
            onChange: (current) => setPage(current),
            hideOnSinglePage: true,
            total: galleryList?.total || 0,
          }}
        />
      </div>

      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title={galleryDetails.id ? "Edit Gallery" : "Add Gallery"}
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="off"
            className="form-control"
            placeholder="Title"
            name="title"
            value={galleryDetails.title}
            onChange={handleTextChange}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            placeholder="Description"
            name="description"
            value={galleryDetails.description}
            onChange={handleTextChange}
            rows={4}
          />
        </Col>
      </Modal>
    </div>
  );
}

export default Gallery;